module.exports = __webpack_public_path__ + "static/media/loading.0c56f100.gif";